import componentInitializer from "@/frontend/utils/componentInitializer"

componentInitializer(() => {
  if (window.location.pathname.includes("/Artwork/")) {
    initPhotoSwipe($("#product-gallery"), false)
  }
})
